import { render, staticRenderFns } from "./ProjectManagementSettingsAdministration.vue?vue&type=template&id=2636a944&scoped=true&"
import script from "./ProjectManagementSettingsAdministration.vue?vue&type=script&lang=ts&"
export * from "./ProjectManagementSettingsAdministration.vue?vue&type=script&lang=ts&"
import style0 from "./ProjectManagementSettingsAdministration.vue?vue&type=style&index=0&id=2636a944&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2636a944",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCol } from 'vuetify/lib/components/VGrid';
import { VProgressCircular } from 'vuetify/lib/components/VProgressCircular';
import { VRow } from 'vuetify/lib/components/VGrid';
import { VSnackbar } from 'vuetify/lib/components/VSnackbar';
installComponents(component, {VBtn,VCol,VProgressCircular,VRow,VSnackbar})
